import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WaitingRoom from '../components/WaitingRoom';
import { useApp } from '../hooks/useApp';
import { useGamePlayers, useGameRoom } from '../hooks/queries';

const WaitingRoomPage = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const {
    socket,
    username,
    currentRoom,
    leaveRoom,
  } = useApp();

  // Use roomId from URL params or fallback to context
  const activeRoomId = roomId || currentRoom;

  // React Query hooks
  const { data: roomData, isLoading: isRoomLoading } = useGameRoom(activeRoomId);
  const { data: playersData, isLoading: isPlayersLoading } = useGamePlayers(activeRoomId);


  const handleBackToLobby = () => {
    leaveRoom();
  };

  return (
    <WaitingRoom
      socket={socket} 
      onBackToLobby={handleBackToLobby}
    />
  );
};

export default WaitingRoomPage;
